// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'pull-forward',
//   templateUrl: './pull-forward.component.html',
//   styleUrls: ['./pull-forward.component.scss']
// })
// export class PullForwardComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }

import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
    selector: 'pull-forward'
})
export class PullForwardComponent extends UpgradeComponent {
    @Input() value: number;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('pullForward', elementRef, injector);
    }
}